import React from "react";
import { Outlet } from "react-router-dom";
import Navbar from "@/components/Navbar";
import Footer from "@/components/Footer";
import FloatingCTAs from "@/components/FloatingCTAs";
import ExitIntentPopup from "@/components/ExitIntentPopup";

export default function Layout() {
  return (
    <div className="min-h-screen flex flex-col bg-white">
      <Navbar />
      <main className="flex-1">
        <Outlet />
      </main>
      <Footer />
      <FloatingCTAs />
      <ExitIntentPopup />
    </div>
  );
}
